import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDressCode = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		d: "M13.95 7.71 15 4.736l-4.9-2.404c-.684 2.243-3.516 2.243-4.2 0L1 4.737 2.05 7.71l1.617-.774v6.732h8.666V6.935z"
	})
});
export default SvgDressCode;
